import {Cureus} from '../Cureus';

Cureus.FinancialRelationships = {};
//= require_tree ./FinancialRelationships